import wowInit from "./module/wowInit";
import adjustViewport from "./module/adjustViewport";
import smoothScroll from "./module/smoothScroll";
import loadScroll from "./module/loadScroll";
import toggleGnav from "./module/toggleGnav";
import toggleSubmenu from "./module/toggleSubmenu";
import showGotop from "./module/showGotop";
import popup from "./module/popup";
import accordion from "./module/accordion";
import headerChangeBg from "./module/headerChangeBg";
import tab from "./module/tab";
import topSlider from "./module/topSlider";
import scrollHint from "./module/scrollHint";
import blockContinuitySubmit from "./module/blockContinuitySubmit"; //フォーム連続送信防止
import FormDeleteInvalid from "./module/FormDeleteInvalid"; //フォームエラー表示
import "../scss/style.scss";

wowInit();
adjustViewport();
smoothScroll();
loadScroll();
toggleGnav();
showGotop();
popup();
accordion();
headerChangeBg();
tab();
toggleSubmenu();
scrollHint();
blockContinuitySubmit();
FormDeleteInvalid();

// トップページ
if (document.body.id === 'top') {
    topSlider();

// 下層ページ
} else if (document.body.id === '') {
    
}


